import { shiftParticipantEntityName } from '../shared/entities/shiftParticipantTypes';
export function getShiftParticipantStorage(context) {
    return context.storage(shiftParticipantEntityName);
}
